module.exports = __webpack_public_path__ + "static/media/Software_CV.0e388d89.pdf";